<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasExample"
    aria-labelledby="offcanvasExampleLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">
        De-Selected Strategies
      </h5>
      <button
        type="button"
        class="btn-close"
        :class="{ 'btn-close-white': isDarkMode }"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <div>
        <ul class="list-group">
          <li
            class="list-group-item"
            v-for="deselected_startegie in filteredStrategies"
            v-bind:key="deselected_startegie"
          >
            <input
              class="form-check-input me-1"
              type="checkbox"
              :value="deselected_startegie"
              :id="deselected_startegie"
              @click="showDeSelectedStrategies(deselected_startegie)"
            />
            <label
              class="form-check-label stretched-link"
              :for="deselected_startegie"
              >{{ deselected_startegie }}</label
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- Save button fixed at the bottom -->
    <div class="offcanvas-footer fixed-bottom">
      <div class="w-100 p-3 justify-content-end d-flex">
        <button
          @click="resetStrats"
          class="btn btn-outline-custom my-2 mx-2 margin-left"
        >
          Show All
        </button>
      </div>
    </div>
  </div>
  <div class="container-fluid my-3">
    <div class="header">
      <h2 style="margin: 0">Dashboard Strategies</h2>
      <div
        style="
          flex: 1;
          display: flex;
          gap: 6px;
          align-items: center;
          margin-left: 16px;
          flex-wrap: wrap;
        "
      >
        <button
          v-if="availableRegions.length > 1"
          class="btn btn-outline-custom my-2"
          type="button"
          @click="selectAllRegions"
          :class="{ active: selectedRegions.length === 0 }"
        >
          All
        </button>
        <button
          v-for="region in availableRegions"
          :key="region"
          class="btn btn-outline-custom my-2"
          type="button"
          @click="toggleRegion(region)"
          :class="{ active: isRegionActive(region) }"
        >
          {{ region.charAt(0).toUpperCase() + region.slice(1) }}
        </button>
      </div>
      <!-- Adding search bar -->
      <div class="container col-md-2 float-end">
        <input
          type="text"
          class="form-control"
          v-model="searchStrats"
          placeholder="Search..."
          id="searchStrats"
          @keyup="searchStratsFn"
        />
      </div>
      <!-- <button @click="resetStrats" class="btn btn-outline-custom my-2">
        Show All
      </button> -->
      <button
        class="btn btn-outline-custom my-2"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasExample"
        aria-controls="offcanvasExample"
      >
        Hidden Strategies
      </button>

      <button
        class="btn btn-outline-custom my-2 pnl-color-btn"
        @click="openColorModal"
        title="Customise PnL colors"
      >
        <span class="pnl-dot" :style="{ background: posColor }"></span>
        <span class="pnl-dot" :style="{ background: negColor }"></span>
        Colors
      </button>
      <button @click="toggleDarkMode" class="btn btn-toggle-dark-mode my-2">
        {{ isDarkMode ? "Light Mode" : "Dark Mode" }}
      </button>
    </div>
    <div class="header">
      <button
        class="btn btn-outline-custom my-2"
        type="button"
        @click="selectTeamFilter(null, null)"
        :class="{ active: team_tab == null && process_type == null }"
      >
        All
      </button>
      <button
        class="btn btn-outline-custom my-2"
        type="button"
        @click="selectTeamFilter(null, 'strategy')"
        :class="{ active: team_tab == null && process_type == 'strategy' }"
      >
        strategy
      </button>
      <button
        class="btn btn-outline-custom my-2"
        type="button"
        @click="selectTeamFilter(null, 'paper')"
        :class="{ active: team_tab == null && process_type == 'paper' }"
      >
        paper
      </button>
      <template v-for="team in team_list" v-bind:key="team">
        <button
          class="btn btn-outline-custom my-2"
          type="button"
          @click="selectTeamFilter(team?.name, 'strategy')"
          :class="{
            active: team_tab == team?.name && process_type == 'strategy',
          }"
        >
          {{ team?.name }}
        </button>
      </template>
      <label class="chief-switch my-2">
        <span class="chief-switch-label">Chief</span>
        <span class="switch">
          <input type="checkbox" :checked="is_chief" @change="selectIsChief" />
          <span class="slider"></span>
        </span>
      </label>
    </div>

    <!-- Summary Bar -->
    <div class="summary-bar my-2" v-if="false">
      <div class="summary-card" :class="pnlClass(totalNetPnl)">
        <div class="summary-label">Net PnL</div>
        <div class="summary-value">{{ formatNumber(totalNetPnl, 2) }}</div>
      </div>
      <div class="summary-card" :class="pnlClass(totalRealised)">
        <div class="summary-label">Realised</div>
        <div class="summary-value">{{ formatNumber(totalRealised, 2) }}</div>
      </div>
      <div class="summary-card" :class="pnlClass(totalUnrealised)">
        <div class="summary-label">Unrealised</div>
        <div class="summary-value">{{ formatNumber(totalUnrealised, 2) }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">Turnover</div>
        <div class="summary-value">{{ formatNumber(totalTurnover, 2) }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">Margin</div>
        <div class="summary-value">{{ formatNumber(totalMargin, 2) }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">Strategies</div>
        <div class="summary-value">{{ sortedPnl.length }}</div>
      </div>
    </div>

    <div v-if="visibleRegions.length === 0" class="no-strats-msg">
      No strategies to display.
    </div>
    <RegionStrategyTable
      v-for="region in visibleRegions"
      :key="region"
      :region="region"
      :logs="logsByRegion[region] || []"
      :visible-logs="visibleLogs"
      :current-time="currentTime"
      :max-margin="(max_margin_by_region[region] || 0) / 100000"
      @toggle-log="delayedLoopTableAndStore"
      @comb-chart="combinedChartRoute"
      @comb-ind-chart="combinedIndPnlChartRoute"
    />
  </div>
  <div v-if="otrData?.length > 0" class="container-fluid my-3">
    <div class="header">
      <h3>Order to Trade Ratio (OTR)</h3>
      <label class="chief-switch my-2">
        <span class="chief-switch-label">Process-wise</span>
        <span class="switch">
          <input
            type="checkbox"
            :checked="otr_is_process"
            @change="toggleOtrProcess"
          />
          <span class="slider"></span>
        </span>
      </label>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered custom-table table-hover">
        <thead>
          <tr>
            <th scope="col">SR.No</th>
            <th
              v-if="otr_is_process"
              class="sortable"
              scope="col"
              @click="sortOtr('process')"
            >
              Process
            </th>
            <th class="sortable" scope="col" @click="sortOtr('team')">Team</th>
            <th class="sortable" scope="col" @click="sortOtr('server')">
              Server
            </th>
            <th
              class="sortable"
              scope="col"
              @click="sortOtr('considered_order_count')"
            >
              Considered Orders
            </th>
            <th class="sortable" scope="col" @click="sortOtr('trade_count')">
              Trade Count
            </th>
            <th class="sortable" scope="col" @click="sortOtr('otr_ratio')">
              OTR Ratio
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in sortedOtrData"
            :key="index"
            :class="{ 'otr-overall-row': row.team === 'overall' }"
          >
            <td>{{ index + 1 }}</td>
            <td v-if="otr_is_process">{{ row.process ?? "-" }}</td>
            <td>{{ row.team }}</td>
            <td>{{ row.server ?? "-" }}</td>
            <td>{{ row.considered_order_count ?? "-" }}</td>
            <td>{{ row.trade_count ?? "-" }}</td>
            <td>{{ row.otr_ratio == null ? "-" : row.otr_ratio }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-if="wewaps.length > 0" class="container-fluid my-3">
    <div class="header">
      <h3>Dashboard vwaps</h3>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered custom-table table-hover">
        <thead>
          <tr>
            <th scope="col">SR.No</th>
            <th scope="col" @click="sort2('index_symbol')" class="sortable">
              index symbol
              <span class="sort-icon" v-if="sortKey2 === 'index_symbol'">{{
                sortDirection2 === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort2('machine')" class="sortable">
              machine
              <span class="sort-icon" v-if="sortKey2 === 'machine'">{{
                sortDirection2 === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort2('exchange_time')" class="sortable">
              exchange time
              <span class="sort-icon" v-if="sortKey2 === 'exchange_time'">{{
                sortDirection2 === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort2('event_time')" class="sortable">
              event time
              <span class="sort-icon" v-if="sortKey2 === 'event_time'">{{
                sortDirection2 === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort2('feed_value')" class="sortable">
              feed value
              <span class="sort-icon" v-if="sortKey2 === 'feed_value'">{{
                sortDirection2 === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th
              scope="col"
              @click="sort2('previous_day_close')"
              class="sortable"
            >
              previous day close
              <span
                class="sort-icon"
                v-if="sortKey2 === 'previous_day_close'"
                >{{ sortDirection2 === 1 ? "▲" : "▼" }}</span
              >
            </th>
            <th
              scope="col"
              @click="sort2('turnover_during_vwap')"
              class="sortable"
            >
              turnover during vwap
              <span
                class="sort-icon"
                v-if="sortKey2 === 'turnover_during_vwap'"
                >{{ sortDirection2 === 1 ? "▲" : "▼" }}</span
              >
            </th>
            <th scope="col" @click="sort2('day_turnover')" class="sortable">
              day turnover
              <span class="sort-icon" v-if="sortKey2 === 'day_turnover'">{{
                sortDirection2 === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col">chart</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(wewap, index) in sortedWewap"
            :key="wewap.id"
            :class="vwaprowClass(wewap)"
          >
            <td>{{ index + 1 }}</td>
            <td class="fw-bold">
              <router-link
                class="process-link"
                :to="`${wewap.index_symbol}/chart/`"
                >{{ wewap.index_symbol }}</router-link
              >
            </td>
            <td>{{ wewap.machine }}</td>
            <td>{{ formatTime(wewap.exchange_time, 0) }}</td>
            <td>{{ formatTime(wewap.event_time, 0) }}</td>
            <td>{{ formatNumber(wewap.feed_value, 2) }}</td>
            <td>{{ formatNumber(wewap.previous_day_close, 2) }}</td>
            <td>{{ formatNumber(wewap.turnover_during_vwap, 2) }}</td>
            <td>{{ formatNumber(wewap.day_turnover, 2) }}</td>
            <td>
              <router-link
                class="chart-link"
                :to="`${wewap.index_symbol}/chart/`"
              >
                <i class="bi bi-graph-up-arrow"></i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- PnL Color Picker Modal -->
  <div
    v-if="showColorModal"
    class="color-modal-overlay"
    @click.self="closeColorModal"
  >
    <div class="color-modal">
      <div class="color-modal-header">
        <span>Customise PnL Colors</span>
        <button class="color-modal-close" @click="closeColorModal">✕</button>
      </div>

      <!-- PnL colors -->
      <div class="color-modal-section-label">PnL Colors</div>
      <div class="color-modal-pickers">
        <div class="color-modal-picker-group">
          <label>Positive</label>
          <input
            type="color"
            :value="previewPos"
            @input="previewPos = $event.target.value"
          />
          <span class="color-modal-sample" :style="{ color: previewPos }"
            >+{{ previewRows[0]?.net }}</span
          >
        </div>
        <div class="color-modal-picker-group">
          <label>Negative</label>
          <input
            type="color"
            :value="previewNeg"
            @input="previewNeg = $event.target.value"
          />
          <span class="color-modal-sample" :style="{ color: previewNeg }"
            >-{{ previewRows[1]?.net }}</span
          >
        </div>
      </div>

      <!-- Table colors -->
      <div class="color-modal-section-label">Table Colors</div>
      <div class="color-modal-pickers">
        <div class="color-modal-picker-group">
          <label>Row BG</label>
          <input
            type="color"
            :value="previewTableBg"
            @input="previewTableBg = $event.target.value"
          />
        </div>
        <div class="color-modal-picker-group">
          <label>Header</label>
          <input
            type="color"
            :value="previewTableHeader"
            @input="previewTableHeader = $event.target.value"
          />
        </div>
        <div class="color-modal-picker-group">
          <label>Text</label>
          <input
            type="color"
            :value="previewTableText"
            @input="previewTableText = $event.target.value"
          />
        </div>
        <div class="color-modal-picker-group">
          <label>Border</label>
          <input
            type="color"
            :value="previewTableBorder"
            @input="previewTableBorder = $event.target.value"
          />
        </div>
      </div>

      <div class="color-modal-preview-label">Live Preview</div>
      <table
        class="color-modal-table"
        :style="{
          '--prev-bg': previewTableBg,
          '--prev-header': previewTableHeader,
          '--prev-text': previewTableText,
          '--prev-border': previewTableBorder,
        }"
      >
        <thead>
          <tr>
            <th>strategy</th>
            <th>net pnl</th>
            <th>realised</th>
            <th>unrealised</th>
            <th>mode</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in previewRows" :key="row.name">
            <td>{{ row.name }}</td>
            <td :style="{ color: row.net >= 0 ? previewPos : previewNeg }">
              {{ row.net >= 0 ? "+" : "" }}{{ row.net }}
            </td>
            <td :style="{ color: row.realised >= 0 ? previewPos : previewNeg }">
              {{ row.realised >= 0 ? "+" : "" }}{{ row.realised }}
            </td>
            <td
              :style="{ color: row.unrealised >= 0 ? previewPos : previewNeg }"
            >
              {{ row.unrealised >= 0 ? "+" : "" }}{{ row.unrealised }}
            </td>
            <td>
              <span
                :class="
                  i === 1
                    ? 'prev-badge prev-badge-halted'
                    : 'prev-badge prev-badge-normal'
                "
                >{{ i === 1 ? "HALTED" : "NORMAL" }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>

      <div class="color-modal-footer">
        <button class="btn btn-outline-secondary btn-sm" @click="resetColors">
          Reset Default
        </button>
        <div style="display: flex; gap: 8px">
          <button
            class="btn btn-outline-secondary btn-sm"
            @click="closeColorModal"
          >
            Cancel
          </button>
          <button class="btn btn-outline-custom btn-sm" @click="applyColors">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import { darkModeMixin } from "@/darkModeMixin.js";
import RegionStrategyTable from "@/components/RegionStrategyTable.vue";

export default {
  name: "HomeView",
  components: { RegionStrategyTable },
  setup() {
    // Get toast interface
    const toast = useToast();
    // Make it available inside methods
    return { toast };
  },
  data() {
    return {
      posColor: localStorage.getItem("pnl_pos_color") || "#2ecc71",
      negColor: localStorage.getItem("pnl_neg_color") || "#e74c3c",
      tableBg: localStorage.getItem("table_bg") || "#1c1c21",
      tableHeader: localStorage.getItem("table_header") || "#111118",
      tableText: localStorage.getItem("table_text") || "#adbed2",
      tableBorder: localStorage.getItem("table_border") || "#363636",
      showColorModal: false,
      previewPos: "#2ecc71",
      previewNeg: "#e74c3c",
      is_chief: false,
      previewTableBg: "#1c1c21",
      previewTableHeader: "#111118",
      previewTableText: "#adbed2",
      previewTableBorder: "#363636",
      previewRows: [],
      abortController: null,
      logs: [],
      has_permission: false,
      previous_log_strat: [],
      isFetchingLogs: false,
      new_log_strat: [],
      sortKey: "name",
      wewaps: [],
      team_tab: null,
      selectedRegions: [],
      availableRegions: [],
      process_type: "strategy",
      sortKey2: "name",
      sortDirection: 1,
      sortDirection2: 1,
      otrData: [],
      otrSortKey: "team",
      otrSortDirection: 1,
      otr_is_process: false,
      intervalLogs: null,
      intervalWewaps: null,
      intervalOtr: null,
      interval_max_margin: null,
      // Shared controller so every request on this view can be cancelled on leave
      requestController: null,
      currentTime: new Date(),
      visibleLogs: [],
      max_margin: "0",
      max_margin_by_region: {},
      start_from: "0",
      visibleLogsglobal: [],
      searchbar: false,
      deselectedStrategies: (
        sessionStorage.getItem("reqdlogs") ||
        localStorage.getItem("reqdlogs") ||
        ""
      ).split(","),
      strategy_list_home_page: (
        sessionStorage.getItem("reqdlogs") ||
        localStorage.getItem("reqdlogs") ||
        ""
      ).split(","),
      searchStrats: "",
      team_list: [
        "quant",
        "quant0",
        "quant1",
        // "quant2",
        "quant3",
        "quant4",
        "quant5",
        "quant6",
        "quant7",
        "okhla_desk",
      ],
    };
  },
  mixins: [darkModeMixin],
  mounted() {
    document.body.style.setProperty("--pnl-pos", this.posColor);
    document.body.style.setProperty("--pnl-neg", this.negColor);
    document.body.style.setProperty("--table-bg", this.tableBg);
    document.body.style.setProperty("--table-header", this.tableHeader);
    document.body.style.setProperty("--table-text", this.tableText);
    document.body.style.setProperty("--table-border", this.tableBorder);
    this.fetchColorPreferences();
    this.getUserRole();
    window.addEventListener("keydown", this.handleKeyDown);
    this.process_type = localStorage.getItem("active_process_type");
    this.team_tab = localStorage.getItem("active_team_tab");
    this.team_tab = this.team_tab == "null" ? null : this.team_tab;
    this.selectedRegions = (localStorage.getItem("active_regions") || "")
      .split(",")
      .filter((r) => r !== "");
    this.is_chief = localStorage.getItem("is_chief") === "true";
    this.process_type = this.process_type == "null" ? null : this.process_type;
    this.requestController = new AbortController();
    this.getRegions();
    this.getLogs1st();
    this.getWewaps();
    this.getOtrData();
    this.get_max_margin();
    this.intervalLogs = setInterval(this.getLogs, 3000);
    this.intervalWewaps = setInterval(this.getWewaps, 10000);
    this.intervalOtr = setInterval(this.getOtrData, 10000);
    this.interval_max_margin = setInterval(this.get_max_margin, 10000);
    const email = localStorage.getItem("email");
    this.has_permission = [
      "anilgupta@pacefin.in",
      "ayushtulsyan@pacefin.in",
      "rahuldubey@pacefin.in",
      "jatinpandey@pacefin.in",
    ].includes(email);

    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
    this.searchStrats = this.$store.state.search;
    this.getTeamList();
  },
  beforeUnmount() {
    clearInterval(this.intervalLogs);
    clearInterval(this.intervalWewaps);
    clearInterval(this.intervalOtr);
    clearInterval(this.interval_max_margin);
    // Cancel any in-flight requests so they don't resolve after leaving the view
    this.requestController?.abort();
    this.abortController?.abort();
    window.removeEventListener("keydown", this.handleKeyDown);
    document.body.style.removeProperty("--pnl-pos");
    document.body.style.removeProperty("--pnl-neg");
    document.body.style.removeProperty("--table-bg");
    document.body.style.removeProperty("--table-header");
    document.body.style.removeProperty("--table-text");
    document.body.style.removeProperty("--table-border");
  },
  beforeCreate() {},
  computed: {
    logsByRegion() {
      const map = {};
      this.logs.forEach((log) => {
        const r = log.region || "india";
        if (!map[r]) map[r] = [];
        map[r].push(log);
      });
      return map;
    },
    visibleRegions() {
      if (!this.selectedRegions.length) return this.availableRegions;
      return this.availableRegions.filter((r) =>
        this.selectedRegions.includes(r)
      );
    },
    maxMarginDivided() {
      return this.max_margin / 100000;
    },
    sortedOtrData() {
      return this.otrData.slice().sort((a, b) => {
        // Keep the "overall" summary row pinned to the bottom regardless of sort
        if (a.team === "overall") return 1;
        if (b.team === "overall") return -1;
        const key = this.otrSortKey;
        const va = a[key];
        const vb = b[key];
        if (isNaN(va) || isNaN(vb)) {
          if (va < vb) return -1 * this.otrSortDirection;
          if (va > vb) return 1 * this.otrSortDirection;
          return 0;
        }
        return (parseFloat(va) - parseFloat(vb)) * this.otrSortDirection;
      });
    },
    sortedWewap() {
      return this.wewaps.slice().sort((a, b) => {
        if (isNaN(a[this.sortKey2]) || isNaN(b[this.sortKey2])) {
          // compare as strings
          if (a[this.sortKey2] < b[this.sortKey2]) {
            return -1 * this.sortDirection2;
          }
          if (a[this.sortKey2] > b[this.sortKey2]) {
            return 1 * this.sortDirection2;
          }
        } else if (
          Number.isInteger(a[this.sortKey2]) ||
          Number.isInteger(b[this.sortKey2])
        ) {
          // compare as integers
          const intA = parseInt(a[this.sortKey2]);
          const intB = parseInt(b[this.sortKey2]);
          if (intA < intB) {
            return -1 * this.sortDirection2;
          }
          if (intA > intB) {
            return 1 * this.sortDirection2;
          }
        } else {
          // compare as floats
          const floatA = parseFloat(a[this.sortKey2]);
          const floatB = parseFloat(b[this.sortKey2]);
          if (floatA < floatB) {
            return -1 * this.sortDirection2;
          }
          if (floatA > floatB) {
            return 1 * this.sortDirection2;
          }
        }
        return 0;
      });
    },
    sortedPnl() {
      return this.logs
        .slice()
        .filter((log) => this.visibleLogs.includes(log.name))
        .sort((a, b) => {
          if (isNaN(a[this.sortKey]) || isNaN(b[this.sortKey])) {
            // compare as strings
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1 * this.sortDirection;
            }
            if (a[this.sortKey] > b[this.sortKey]) {
              return 1 * this.sortDirection;
            }
          } else if (
            Number.isInteger(a[this.sortKey]) ||
            Number.isInteger(b[this.sortKey])
          ) {
            // compare as integers
            const intA = a[this.sortKey];
            const intB = b[this.sortKey];
            if (intA < intB) {
              return -1 * this.sortDirection;
            }
            if (intA > intB) {
              return 1 * this.sortDirection;
            }
          } else {
            // compare as floats
            const floatA = parseFloat(a[this.sortKey]);
            const floatB = parseFloat(b[this.sortKey]);
            if (floatA < floatB) {
              return -1 * this.sortDirection;
            }
            if (floatA > floatB) {
              return 1 * this.sortDirection;
            }
          }
          return 0;
        });
    },
    totalNetPnl() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.net_pnl);
        }
        return total;
      }, 0);
    },
    totalRealised() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.realised);
        }
        return total;
      }, 0);
    },
    totalUnrealised() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.unrealised);
        }
        return total;
      }, 0);
    },
    totalCost() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.cost);
        }
        return total;
      }, 0);
    },
    totalTurnover() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.turnover);
        }
        return total;
      }, 0);
    },
    totalStrikeTurnover() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.strike_turnover);
        }
        return total;
      }, 0);
    },
    totalNetExposure() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.net_exposure);
        }
        return total;
      }, 0);
    },
    totalGrossExposure() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.gross_exposure);
        }
        return total;
      }, 0);
    },
    totalOpenLongExposure() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.open_long_exposure);
        }
        return total;
      }, 0);
    },
    totalOpenShortExposure() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.open_short_exposure);
        }
        return total;
      }, 0);
    },
    totalNetOpenAmount() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.net_open_amount);
        }
        return total;
      }, 0);
    },
    totalGrossOpenAmount() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.gross_open_amount);
        }
        return total;
      }, 0);
    },
    totalMargin() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.margin || 0);
        }
        return total;
      }, 0);
    },
    totalmaxMargin() {
      return this.logs.reduce((total, log) => {
        if (this.visibleLogs.includes(log.name)) {
          return total + parseFloat(log.max_margin || 0);
        }
        return total;
      }, 0);
    },
    filteredStrategies() {
      return this.deselectedStrategies.filter((strategy) => strategy !== "");
    },
  },
  methods: {
    getUserRole() {
      axios
        .get("/api/user/groups/", { signal: this.requestController?.signal })
        .then((response) => {
          console.log(response.data);
          this.$store.commit("setUserRoles", response.data);
          this.groupLoaded = true;
          console.log("states", this.$store.state);
          if (
            response.data?.is_thailand_user &&
            response.data?.role.toLowerCase() != "admin"
          ) {
            this.$router.push("/thailand/");
          }
        })
        .catch((error) => {
          console.error(error);
          this.groupLoaded = true;
        });
    },
    selectTeamFilter(team, process_type) {
      this.team_tab = team ?? null;
      this.process_type = process_type ?? null;
      localStorage.setItem("active_team_tab", this.team_tab);
      localStorage.setItem("active_process_type", this.process_type);
      setTimeout(() => {
        this.getLogs();
        this.get_max_margin(true);
      }, 500);
    },
    selectAllRegions() {
      this.selectedRegions = [];
      localStorage.setItem("active_regions", "");
      this.refetchForRegionChange();
    },
    toggleRegion(region) {
      if (this.selectedRegions.includes(region)) {
        this.selectedRegions = this.selectedRegions.filter((r) => r !== region);
      } else {
        this.selectedRegions.push(region);
      }
      // Selecting every available region is the same as "All" (empty).
      if (this.selectedRegions.length >= this.availableRegions.length) {
        this.selectedRegions = [];
      }
      localStorage.setItem("active_regions", this.selectedRegions.join(","));
      this.refetchForRegionChange();
    },
    refetchForRegionChange() {
      setTimeout(() => {
        this.getLogs();
        this.get_max_margin(true);
      }, 300);
    },
    isRegionActive(region) {
      return this.selectedRegions.includes(region);
    },
    getRegions() {
      axios
        .get("api/regions/")
        .then((response) => {
          this.availableRegions = response.data.regions || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectIsChief() {
      this.is_chief = !this.is_chief;
      localStorage.setItem("is_chief", this.is_chief);
      setTimeout(() => {
        this.getLogs();
        this.get_max_margin(true);
      }, 500);
    },

    getTeamList() {
      axios
        .get("strategies/team-list/?is_dashboard=true", {
          signal: this.requestController?.signal,
        })
        .then((res) => {
          this.team_list = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    combinedChartRoute(region = null) {
      const routeObject = { path: "combined_chart/" };

      routeObject.query = {
        team_name: this.team_tab,
        process_type: this.process_type,
        region: region || undefined,
      };
      this.$router.push(routeObject);
    },
    combinedIndPnlChartRoute(region = null) {
      const routeObject = { path: "combined-ind-pnl/" };

      routeObject.query = {
        team_name: this.team_tab,
        process_type: this.process_type,
        region: region || undefined,
      };

      this.$router.push(routeObject);
    },
    handleKeyDown(event) {
      // Check if Shift and S keys are pressed
      if (event.shiftKey && event.key === "S") {
        // Prevent the default action of the keypress event
        event.preventDefault();

        // Focus on the input field
        let searchStrats_id = document.getElementById("searchStrats");
        if (searchStrats_id) {
          searchStrats_id.focus();
        }
      }
    },
    delayedLoopTableAndStore(log_ins) {
      if (
        !this.deselectedStrategies.includes(log_ins.name) &&
        log_ins.name != "" &&
        log_ins.name != null
      ) {
        this.deselectedStrategies.push(log_ins.name);
      }
      sessionStorage.setItem("reqdlogs", this.deselectedStrategies);
      localStorage.setItem("reqdlogs", this.deselectedStrategies);
      this.max_margin = "0";
      this.start_from = "0";
      if (this.visibleLogs.includes(log_ins.name)) {
        this.visibleLogs = this.visibleLogs.filter(
          (name) => name !== log_ins.name
        );
      } else {
        this.visibleLogs.push(log_ins.name);
      }
    },
    loopTableAndStore() {
      // Select the table rows
      var tableRows = document.querySelectorAll(".strats tr");
      this.visibleLogsglobal = [];
      this.strategy_list_home_page = [];
      for (let i = 1; i < tableRows.length - 1; i++) {
        // Find the data in the second column (index 1) and push to the array
        var row = tableRows[i];
        var rowData = row.cells[1].textContent;
        if (rowData != "") {
          this.visibleLogsglobal.push(rowData);
          this.strategy_list_home_page.push(rowData);
        }
      }

      // Log the array togetLogs1st the console (you can use it as needed)
      console.log(this.visibleLogsglobal);
      sessionStorage.setItem("reqdlogs", this.visibleLogsglobal);
      localStorage.setItem("reqdlogs", this.visibleLogsglobal);
      this.max_margin = "0";
      this.start_from = "0";
    },
    getLogs1st() {
      // Store the count of previous logs
      const previousLogsCount = this.logs.length;
      this.previous_log_strat = [];
      this.previous_log_strat = [...this.new_log_strat];
      var strategy_list_home_page_get = (
        sessionStorage.getItem("reqdlogs") ||
        localStorage.getItem("reqdlogs") ||
        ""
      ).split(",");
      var strategy_list_local_home = strategy_list_home_page_get.filter(
        (item) => item !== ""
      );
      axios
        .post(
          "api/logs/",
          {
            deselected_strats: strategy_list_local_home,
            search_bar_value: "",
            team_name: this.team_tab,
            regions: this.selectedRegions.length
              ? this.selectedRegions
              : this.availableRegions,
            process_type: this.process_type,
          },
          { signal: this.requestController?.signal }
        )
        .then((response) => {
          this.logs = response.data.data;
          this.logs?.map((log) => {
            if (log?.machine) {
              log.team =
                log?.machine?.split("@")?.length > 0
                  ? log?.machine?.split("@")[0]
                  : log?.machine;
              log.machine =
                log?.machine?.split("@")?.length > 0
                  ? log?.machine?.split("@")[1]
                  : log?.machine;
            }
          });
          this.strategy_list_home_page = response.data.strategy_list;
          this.new_log_strat = response.data.strategy_list;
          this.$store.commit("setStrategyList", response.data.strategy_list);

          // console.log(response.data);
          // Add all log names to visibleLogs array
          this.visibleLogs = this.logs.map((log) => log.name);
          // Get the count of new logs
          const newLogsCount = response.data.data.length;
          if (previousLogsCount === 0) {
            // Initial fetch, don't display alerts
            return;
          } else if (newLogsCount > previousLogsCount) {
            // Get the last added log
            // const addedLogs = response.data.data.slice(previousLogsCount);
            // addedLogs.forEach((addedLog) => {
            //   // const message = `Strategy ${addedLog.name} Started`;
            //   // Display the toast message using vue-toastification
            //   // this.toast.success(message);
            // });
          }
          if (newLogsCount != previousLogsCount) {
            this.max_margin = "0";
            this.start_from = "0";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getLogs() {
      if (!this.isFetchingLogs) {
        // Store the count of previous logs
        var previousLogsCount = this.logs.length;
        this.previous_log_strat = [];
        this.previous_log_strat = [...this.new_log_strat];
        var strategy_list_home_page_get = (
          sessionStorage.getItem("reqdlogs") ||
          localStorage.getItem("reqdlogs") ||
          ""
        ).split(",");
        var strategy_list_local_home = strategy_list_home_page_get.filter(
          (item) => item !== ""
        );
        this.isFetchingLogs = true;

        axios
          .post(
            "api/logs/",
            {
              deselected_strats: strategy_list_local_home,
              search_bar_value: this.searchStrats || "",
              team_name: this.team_tab,
              regions: this.selectedRegions.length
                ? this.selectedRegions
                : this.availableRegions,
              process_type: this.process_type,
              is_chief: this.is_chief ? 1 : 0,
            },
            { timeout: 5000, signal: this.requestController?.signal }
          )
          .then((response) => {
            this.isFetchingLogs = false;
            this.logs = response.data.data;
            if (this.logs?.length > 0) {
              this.logs?.map((log) => {
                if (log?.machine) {
                  log.team =
                    log?.machine?.split("@")?.length > 0
                      ? log?.machine?.split("@")[0]
                      : log?.machine;
                  log.machine =
                    log?.machine?.split("@")?.length > 0
                      ? log?.machine?.split("@")[1]
                      : log?.machine;
                }
              });
            }
            console.log(this.logs);
            this.strategy_list_home_page = response.data.strategy_list;
            this.new_log_strat = response.data.strategy_list;
            this.$store.commit("setStrategyList", response.data.strategy_list);
            const newLogsCount = response.data.data.length;
            console.log(this.searchbar);
            if (this.searchbar) {
              const allLogNames = this.logs.map((log) => log.name);
              // Set all logs as visible
              this.visibleLogs = allLogNames;
              this.searchbar = false;
              return;
            }
            if (newLogsCount > previousLogsCount) {
              // Get the last added log
              const addedLogs = response.data.data.slice(previousLogsCount);
              // addedLogs.forEach((addedLog) => {
              //   const message = `Strategy ${addedLog.name} Started`;
              //   // Display the toast message using vue-toastification
              //   this.toast.success(message);
              // });
              // Add only the new log names to visibleLogs array
              const newLogNames = addedLogs.map((log) => log.name);
              this.visibleLogs = this.visibleLogs.concat(newLogNames);
            }
            if (newLogsCount != previousLogsCount) {
              this.max_margin = "0";
              this.start_from = "0";
            }
            this.visibleLogs = response.data?.strategy_list;
          })
          .catch((error) => {
            this.isFetchingLogs = false;
            console.log(error);
          });
      }
    },

    get_max_margin(team_change = false) {
      if (this.abortController) {
        this.abortController.abort();
      }
      const localController = new AbortController();
      this.abortController = localController;

      var strategy_list = (
        sessionStorage.getItem("reqdlogs") ||
        localStorage.getItem("reqdlogs") ||
        ""
      ).split(",");
      let mm = this.max_margin;
      let mmr = this.max_margin_by_region || {};
      // if (
      //   sessionStorage.getItem("reqdlogs") == null &&
      //   localStorage.getItem("reqdlogs") == null
      // ) {
      //   mm = "0";
      //   this.start_from = "0";
      // }

      if (this.new_log_strat?.length != this.previous_log_strat?.length) {
        mm = "0";
        mmr = {};
        this.start_from = "0";
      }
      var strategy_list_local = strategy_list.filter((item) => item !== "");
      if (team_change) {
        mm = "0";
        mmr = {};
        this.start_from = "0";
      }
      axios
        .post(
          "api/max-margin/",
          {
            last_max_margin: mm,
            last_max_margin_by_region: mmr,
            last_id_recieved: this.start_from,
            strategy_list: strategy_list_local,
            team_name: this.team_tab,
            regions: this.selectedRegions.length
              ? this.selectedRegions
              : this.availableRegions,
            process_type: this.process_type,
            search_bar_value: this.searchStrats || "",
            is_chief: this.is_chief ? 1 : 0,
          },
          { signal: this.abortController.signal }
        )
        .then((response) => {
          this.max_margin = response.data.max_margin;
          this.max_margin_by_region = response.data.max_margin_by_region || {};
          this.start_from = response.data.last_id_recieved;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.abortController === localController) {
            this.abortController = null;
          }
        });
    },
    fetchColorPreferences() {
      axios
        .get("/auth/preferences/")
        .then((res) => {
          const d = res.data;
          if (d.pnl_pos_color) this.setPosColor(d.pnl_pos_color);
          if (d.pnl_neg_color) this.setNegColor(d.pnl_neg_color);
          if (d.table_bg) {
            this.tableBg = d.table_bg;
            localStorage.setItem("table_bg", d.table_bg);
            document.body.style.setProperty("--table-bg", d.table_bg);
          }
          if (d.table_header) {
            this.tableHeader = d.table_header;
            localStorage.setItem("table_header", d.table_header);
            document.body.style.setProperty("--table-header", d.table_header);
          }
          if (d.table_text) {
            this.tableText = d.table_text;
            localStorage.setItem("table_text", d.table_text);
            document.body.style.setProperty("--table-text", d.table_text);
          }
          if (d.table_border) {
            this.tableBorder = d.table_border;
            localStorage.setItem("table_border", d.table_border);
            document.body.style.setProperty("--table-border", d.table_border);
          }
        })
        .catch(() => {});
    },
    setPosColor(val) {
      this.posColor = val;
      localStorage.setItem("pnl_pos_color", val);
      document.body.style.setProperty("--pnl-pos", val);
    },
    setNegColor(val) {
      this.negColor = val;
      localStorage.setItem("pnl_neg_color", val);
      document.body.style.setProperty("--pnl-neg", val);
    },
    openColorModal() {
      this.previewPos = this.posColor;
      this.previewNeg = this.negColor;
      this.previewTableBg = this.tableBg;
      this.previewTableHeader = this.tableHeader;
      this.previewTableText = this.tableText;
      this.previewTableBorder = this.tableBorder;
      const rnd = (min, max) =>
        (
          (Math.random() > 0.5 ? 1 : -1) *
          (Math.random() * (max - min) + min)
        ).toFixed(2);
      this.previewRows = [
        "Strategy A",
        "Strategy B",
        "Strategy C",
        "Strategy D",
        "Strategy E",
      ].map((name) => ({
        name,
        net: parseFloat(rnd(0.5, 40)),
        realised: parseFloat(rnd(0.5, 25)),
        unrealised: parseFloat(rnd(0, 18)),
      }));
      this.showColorModal = true;
    },
    closeColorModal() {
      this.showColorModal = false;
    },
    applyColors() {
      this.setPosColor(this.previewPos);
      this.setNegColor(this.previewNeg);
      this.tableBg = this.previewTableBg;
      this.tableHeader = this.previewTableHeader;
      this.tableText = this.previewTableText;
      this.tableBorder = this.previewTableBorder;
      localStorage.setItem("table_bg", this.tableBg);
      localStorage.setItem("table_header", this.tableHeader);
      localStorage.setItem("table_text", this.tableText);
      localStorage.setItem("table_border", this.tableBorder);
      document.body.style.setProperty("--table-bg", this.tableBg);
      document.body.style.setProperty("--table-header", this.tableHeader);
      document.body.style.setProperty("--table-text", this.tableText);
      document.body.style.setProperty("--table-border", this.tableBorder);
      axios
        .patch("/auth/preferences/", {
          pnl_pos_color: this.posColor,
          pnl_neg_color: this.negColor,
          table_bg: this.tableBg,
          table_header: this.tableHeader,
          table_text: this.tableText,
          table_border: this.tableBorder,
        })
        .catch(() => {});
      this.showColorModal = false;
    },
    resetColors() {
      this.previewPos = "#2ecc71";
      this.previewNeg = "#e74c3c";
      this.previewTableBg = "#1c1c21";
      this.previewTableHeader = "#111118";
      this.previewTableText = "#adbed2";
      this.previewTableBorder = "#363636";
      this.setPosColor("#2ecc71");
      this.setNegColor("#e74c3c");
      this.tableBg = "#1c1c21";
      this.tableHeader = "#111118";
      this.tableText = "#adbed2";
      this.tableBorder = "#363636";
      localStorage.removeItem("table_bg");
      localStorage.removeItem("table_header");
      localStorage.removeItem("table_text");
      localStorage.removeItem("table_border");
      document.body.style.setProperty("--table-bg", "#1c1c21");
      document.body.style.setProperty("--table-header", "#111118");
      document.body.style.setProperty("--table-text", "#adbed2");
      document.body.style.setProperty("--table-border", "#363636");
      axios
        .patch("/auth/preferences/", {
          pnl_pos_color: "#2ecc71",
          pnl_neg_color: "#e74c3c",
          table_bg: "#1c1c21",
          table_border: "#363636",
          table_header: "#111118",
          table_text: "#adbed2",
        })
        .catch(() => {});
    },
    pnlClass(val) {
      const n = parseFloat(val);
      if (n > 0) return "pnl-positive";
      if (n < 0) return "pnl-negative";
      return "";
    },
    statusBadgeClass(status) {
      if (!status) return "badge-unknown";
      const s = status.toLowerCase();
      if (s === "connected") return "badge-connected";
      if (s === "stopped") return "badge-stopped";
      if (s === "paused") return "badge-paused";
      if (s === "disconnected") return "badge-disconnected";
      if (s === "no data") return "badge-no-data";
      if (s === "old data") return "badge-old-data";
      if (s === "unexpected") return "badge-unexpected";
      if (s === "fail") return "badge-fail";
      return "badge-unknown";
    },
    modeBadgeClass(mode) {
      if (!mode) return "badge-mode-unknown";
      if (mode === "NORMAL") return "badge-mode-normal";
      if (mode === "HALTED") return "badge-mode-halted";
      if (mode === "LIQUIDATE_ONLY") return "badge-mode-liquidate";
      return "badge-mode-unknown";
    },
    formatNumber(num, des) {
      return parseFloat(num).toFixed(des);
    },
    formatTime(num, des) {
      console.log(des);
      if (num) {
        let time = num.split(".");
        return time.length > 0 ? time[0] : null;
      }
      return null;
    },
    sort(key) {
      if (key === this.sortKey) {
        this.sortDirection *= -1;
      } else {
        this.sortKey = key;
        this.sortDirection = 1;
      }
    },
    rowClass(log) {
      const fiveMinutesInMilliseconds = 5 * 60 * 1000;
      const currentYear = this.currentTime.getFullYear();
      const currentMonth = this.currentTime.getMonth();
      const currentDate = this.currentTime.getDate();
      const updatedTime = new Date(
        currentYear,
        currentMonth,
        currentDate,
        log.time.slice(0, 2),
        log.time.slice(2, 4),
        log.time.slice(4)
      );
      return this.currentTime - updatedTime > fiveMinutesInMilliseconds
        ? "red"
        : "";
    },
    getWewaps() {
      axios
        .get("api/vwaps/", { signal: this.requestController?.signal })
        .then((response) => {
          this.wewaps = response.data;
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getOtrData() {
      axios
        .post(
          "api/otr-data/",
          { is_process: this.otr_is_process ? 1 : 0 },
          {
            signal: this.requestController?.signal,
          }
        )
        .then((response) => {
          this.otrData = response.data?.data ?? [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toggleOtrProcess() {
      this.otr_is_process = !this.otr_is_process;
      this.getOtrData();
    },
    sortOtr(key) {
      if (key === this.otrSortKey) {
        this.otrSortDirection *= -1;
      } else {
        this.otrSortKey = key;
        this.otrSortDirection = 1;
      }
    },
    sort2(key) {
      if (key === this.sortKey2) {
        this.sortDirection2 *= -1;
      } else {
        this.sortKey2 = key;
        this.sortDirection2 = 1;
      }
    },
    vwaprowClass(wewap) {
      const diff = Math.abs(wewap.feed_value - wewap.ltp_value);
      const relativeDiff = Math.abs(
        (wewap.feed_value - wewap.ltp_value) / wewap.ltp_value
      );
      const fiveMinutesInMilliseconds = 5 * 60 * 1000;
      const currentYear = this.currentTime.getFullYear();
      const currentMonth = this.currentTime.getMonth();
      const currentDate = this.currentTime.getDate();
      const updatedTime = new Date(
        currentYear,
        currentMonth,
        currentDate,
        wewap.event_time.slice(0, 2),
        wewap.event_time.slice(2, 4),
        wewap.event_time.slice(4)
      );
      if (
        diff >= 5.0 ||
        relativeDiff > 0.0005 ||
        this.currentTime - updatedTime > fiveMinutesInMilliseconds
      ) {
        return "highlighted-row";
      }
      return "";
    },
    toggleLogVisibility(logName) {
      if (this.visibleLogs.includes(logName)) {
        this.visibleLogs = this.visibleLogs.filter((name) => name !== logName);
      } else {
        this.visibleLogs.push(logName);
      }
    },
    resetStrats() {
      sessionStorage.removeItem("reqdlogs");
      localStorage.removeItem("reqdlogs");
      location.reload();
    },
    searchStratsFn() {
      this.$store.commit("setSearchValue", this.searchStrats);
      this.max_margin = "0";
      this.start_from = "0";
      if (this.searchStrats != "" && this.searchStrats.length > 2) {
        this.searchbar = true;
      } else {
        this.searchbar = false;
      }
    },
    showDeSelectedStrategies(strategy) {
      let de_select_stratgy =
        (
          localStorage.getItem("reqdlogs") || sessionStorage.getItem("reqdlogs")
        ).split(",") || [];
      console.log(de_select_stratgy);
      if (de_select_stratgy.includes(strategy)) {
        let index = de_select_stratgy.indexOf(strategy);
        de_select_stratgy.splice(index, 1);
        this.deselectedStrategies.splice(index, 1);
        localStorage.setItem("reqdlogs", de_select_stratgy);
        sessionStorage.setItem("reqdlogs", de_select_stratgy);
        if (!this.visibleLogs.includes(strategy)) {
          this.visibleLogs.push(strategy);
        }
      }
    },
  },
  watch: {
    searchStrats() {
      this.max_margin = "0";
      this.start_from = "0";
    },
  },
  created() {
    this.searchStrats = "";
  },
};
</script>
<style>
body.dark-mode,
body.dark-mode .offcanvas {
  background-color: rgb(36, 36, 36) !important;
  color: rgb(173, 190, 210) !important;
  /* Add any other styles for dark mode */
}

body.dark-mode .custom-table {
  background-color: rgb(28, 28, 33) !important;
  color: #fff !important;
}
body.dark-mode .strats {
  background-color: var(--table-bg, rgb(28, 28, 33)) !important;
}

body.dark-mode .pace-navbar {
  background-color: rgb(28, 28, 33);
}

body.dark-mode .header h2::after,
body.dark-mode .header h3::after,
.header h2::before,
.header h3::before {
  background-color: rgb(167, 50, 42);
}

body.dark-mode a {
  color: rgb(173, 190, 210) !important;
}

.btn.btn-toggle-dark-mode {
  background-color: #333 !important;
  color: #fff !important;
}

body.dark-mode .custom-table th {
  vertical-align: middle !important;
  text-align: center !important;
  font-size: 15px;
  color: rgb(173, 190, 210) !important;
  padding: 0.6rem 0.2rem !important;
  background-color: rgb(28, 28, 33) !important;
  font-weight: 900;
}
body.dark-mode .strats th {
  color: var(--table-text, rgb(173, 190, 210)) !important;
  background-color: var(--table-bg, rgb(28, 28, 33)) !important;
}

body.dark-mode table {
  border-color: rgb(54, 54, 54) !important;
}
body.dark-mode .strats,
body.dark-mode .strats td,
body.dark-mode .strats th {
  border-color: var(--table-border, rgb(54, 54, 54)) !important;
}

table {
  border-color: #dee2e6 !important;
}

body.dark-mode .custom-table td {
  background-color: rgb(28, 28, 33);
  color: rgb(173, 190, 210) !important;
  font-weight: 600;
}
body.dark-mode .strats td {
  background-color: var(--table-bg, rgb(28, 28, 33));
  color: var(--table-text, rgb(173, 190, 210)) !important;
}

body.dark-mode .form-check-input[type="checkbox"],
body.dark-mode .form-check-input[type="radio"] {
  background-color: rgb(167, 50, 42) !important;
  border-radius: 80% !important;
  border-color: rgb(167, 50, 42) !important;
}

body.dark-mode .custom-table tr.highlighted-row td {
  color: #c16969 !important;
}
body.dark-mode .strats tr.highlighted-row td {
  background-color: rgba(193, 105, 105, 0.07) !important;
}

body.dark-mode .custom-table tr.red td {
  color: #c16969 !important/* Your preferred color for red rows */;
}

.header {
  display: flex;
  align-items: center;
}
.header {
  display: flex;
  align-items: center;
}

.btn {
  padding: 8px 16px;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn.btn-outline-custom {
  color: #f3756c;
  border-color: #f3756c;
  margin-right: 1%;
}

.btn.btn-outline-custom:hover,
.btn.btn-outline-custom.active {
  background-color: #f3756c;
  color: #fff;
}

/* Chief is an independent on/off toggle, shown as a switch and separated
   from the mutually-exclusive All / strategy / paper / team filters. */
.chief-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 0.75rem;
  cursor: pointer;
  user-select: none;
}
.chief-switch .chief-switch-label {
  color: #f3756c;
  font-weight: 600;
}
.chief-switch .switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}
.chief-switch .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.chief-switch .slider {
  position: absolute;
  inset: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.3s ease;
}
.chief-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.3s ease;
}
.chief-switch input:checked + .slider {
  background-color: #f3756c;
}
.chief-switch input:checked + .slider::before {
  transform: translateX(20px);
}

body.dark-mode .table-hover tbody tr:hover td,
body.dark-mode .table-hover tbody tr:hover th {
  background-color: #555 !important; /* Even darker background color on hover in dark mode */
}
.margin-left {
  width: 21rem;
}
.custom-table td .bg-red {
  background-color: rgb(167, 50, 42) !important;
}
.cursor-pointer {
  cursor: pointer;
}
a#tv-attr-logo {
  display: none;
}

/* Sort indicator */
th.sortable {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.otr-overall-row {
  font-weight: 700;
}
.sort-icon {
  font-size: 0.7rem;
  opacity: 0.8;
  margin-left: 2px;
}

/* PnL coloring — driven by CSS variables set per user */
.pnl-positive {
  color: var(--pnl-pos, #2ecc71) !important;
  font-weight: 700;
}
.pnl-negative {
  color: var(--pnl-neg, #e74c3c) !important;
  font-weight: 700;
}
body.dark-mode .custom-table tr.red td.pnl-positive,
body.dark-mode .custom-table tr td.pnl-positive {
  color: var(--pnl-pos, #2ecc71) !important;
}
body.dark-mode .custom-table tr.red td.pnl-negative,
body.dark-mode .custom-table tr td.pnl-negative {
  color: var(--pnl-neg, #e74c3c) !important;
}

/* Color picker widget */
/* Colors button with dots */
.pnl-color-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}
.pnl-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Color picker modal overlay */
.color-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.color-modal {
  background: #1e1e2e;
  border-radius: 14px;
  padding: 24px;
  width: 520px;
  max-width: 95vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid #2e2e40;
}
.color-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 0.95rem;
  color: #ccc;
}
.color-modal-close {
  background: none;
  border: none;
  color: #888;
  font-size: 1.1rem;
  cursor: pointer;
  line-height: 1;
}
.color-modal-close:hover {
  color: #fff;
}
.color-modal-pickers {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  background: #14141f;
  border-radius: 10px;
  padding: 16px 20px;
}
.color-modal-picker-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.color-modal-picker-group label {
  font-size: 0.7rem;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.color-modal-picker-group input[type="color"] {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  background: none;
}
.color-modal-sample {
  font-size: 1.2rem;
  font-weight: 700;
  min-width: 80px;
}
.color-modal-preview-label {
  font-size: 0.65rem;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}
.color-modal-section-label {
  font-size: 0.65rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 14px 0 6px;
}
.color-modal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
  margin-bottom: 20px;
  border: 1px solid var(--prev-border, #2a2a3a);
}
.color-modal-table th {
  background: var(--prev-header, #11111b);
  color: var(--prev-text, #555);
  font-weight: 500;
  padding: 6px 10px;
  text-align: right;
  border-bottom: 1px solid var(--prev-border, #2a2a3a);
}
.color-modal-table th:first-child {
  text-align: left;
}
.prev-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.prev-badge-normal {
  background: rgba(46, 204, 113, 0.12);
  color: #2ecc71;
  border: 1px solid #2ecc71;
}
.prev-badge-halted {
  background: rgba(231, 76, 60, 0.12);
  color: #e74c3c;
  border: 1px solid #e74c3c;
}
.color-modal-table td {
  padding: 7px 10px;
  border-bottom: 1px solid var(--prev-border, #1e1e2e);
  background-color: var(--prev-bg, transparent);
  color: var(--prev-text, #aaa);
  text-align: right;
  font-weight: 700;
}
.color-modal-table td:first-child {
  text-align: left;
  font-weight: 400;
}
.color-modal-table tr:nth-child(even) td {
  background: var(--prev-bg, rgba(255, 255, 255, 0.02));
  filter: brightness(1.08);
}
.color-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Status badges */
.status-badge,
.mode-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
.badge-connected {
  background-color: rgba(46, 204, 113, 0.15);
  color: #27ae60;
  border: 1px solid #2ecc71;
}
.badge-stopped {
  background-color: rgba(127, 140, 141, 0.15);
  color: #7f8c8d;
  border: 1px solid #95a5a6;
}
.badge-paused {
  background-color: rgba(52, 152, 219, 0.15);
  color: #2980b9;
  border: 1px solid #3498db;
}
.badge-disconnected {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
  border: 1px solid #e74c3c;
}
.badge-no-data {
  background-color: rgba(241, 196, 15, 0.15);
  color: #b7950b;
  border: 1px solid #f1c40f;
}
.badge-old-data {
  background-color: rgba(230, 126, 34, 0.15);
  color: #ca6f1e;
  border: 1px solid #e67e22;
}
.badge-unexpected {
  background-color: rgba(155, 89, 182, 0.15);
  color: #7d3c98;
  border: 1px solid #9b59b6;
}
.badge-fail {
  background-color: rgba(231, 76, 60, 0.25);
  color: #922b21;
  border: 1px solid #e74c3c;
  font-weight: 800;
}
.badge-unknown {
  background-color: rgba(127, 140, 141, 0.1);
  color: #95a5a6;
  border: 1px solid #bdc3c7;
}

.badge-mode-normal {
  background-color: rgba(52, 152, 219, 0.15);
  color: #3498db;
  border: 1px solid #3498db;
}
.badge-mode-halted {
  background-color: rgba(231, 76, 60, 0.15);
  color: #e74c3c;
  border: 1px solid #e74c3c;
}
.badge-mode-liquidate {
  background-color: rgba(230, 126, 34, 0.15);
  color: #e67e22;
  border: 1px solid #e67e22;
}
.badge-mode-unknown {
  background-color: rgba(127, 140, 141, 0.15);
  color: #95a5a6;
  border: 1px solid #7f8c8d;
}

/* Summary bar */
.summary-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* ── Light mode summary cards ── */
.summary-card {
  flex: 1 1 100px;
  min-width: 100px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  text-align: center;
  border-top: 3px solid #e2e8f0;
}
.summary-card.pnl-positive {
  border-top-color: #198754;
  background-color: #f0fdf4;
  border-color: #bbf7d0;
}
.summary-card.pnl-negative {
  border-top-color: #dc3545;
  background-color: #fff5f5;
  border-color: #fecdd3;
}
.summary-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6c757d;
  font-weight: 600;
}
.summary-value {
  font-size: 1.15rem;
  font-weight: 700;
  margin-top: 4px;
  color: #212529;
}
.summary-card.pnl-positive .summary-value {
  color: #198754;
}
.summary-card.pnl-negative .summary-value {
  color: #dc3545;
}

/* Sticky columns for mobile horizontal scroll */
.strats td.col-sticky-0 {
  position: sticky;
  left: 0;
  z-index: 3;
  min-width: 40px;
}
.strats td.col-sticky-1 {
  position: sticky;
  left: 40px;
  z-index: 3;
  min-width: 55px;
}
.strats td.col-sticky-2 {
  position: sticky;
  left: 95px;
  z-index: 3;
  min-width: 130px;
}
/* Strategies table scroll container — enables sticky header */
.strats-wrapper {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  overflow-x: auto;
}
/* Sticky header row — sticks to top within the scroll container */
.strats thead th {
  position: sticky;
  top: 0;
  z-index: 10;
}
/* Corner cells: sticky both horizontally and vertically */
.strats th.col-sticky-0 {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 15;
  min-width: 40px;
}
.strats th.col-sticky-1 {
  position: sticky;
  left: 40px;
  top: 0;
  z-index: 15;
  min-width: 55px;
}
.strats th.col-sticky-2 {
  position: sticky;
  left: 95px;
  top: 0;
  z-index: 15;
  min-width: 130px;
}
/* ── Light mode overrides ── */

/* Table header: distinct background so it reads as a header */
.custom-table thead th {
  background-color: #f1f5f9 !important;
  color: #374151 !important;
  border-bottom: 2px solid #cbd5e1 !important;
}
/* Sticky thead cells must match */
.strats th.col-sticky-0,
.strats th.col-sticky-1,
.strats th.col-sticky-2 {
  background-color: #f1f5f9 !important;
}
/* Sticky td cells in light mode */
.strats td.col-sticky-0,
.strats td.col-sticky-1,
.strats td.col-sticky-2 {
  background-color: #ffffff;
}
/* Sticky cell hover fix — match Bootstrap table-hover */
.strats tr:hover td.col-sticky-0,
.strats tr:hover td.col-sticky-1,
.strats tr:hover td.col-sticky-2 {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

/* ── Dark mode overrides ── */
body.dark-mode .custom-table thead th {
  background-color: rgb(28, 28, 33) !important;
  color: rgb(173, 190, 210) !important;
  border-bottom-color: rgb(54, 54, 54) !important;
}
body.dark-mode .strats thead th,
body.dark-mode .strats tbody tr:last-child th {
  background-color: var(--table-header, rgb(17, 17, 24)) !important;
  color: var(--table-text, rgb(173, 190, 210)) !important;
  border-bottom-color: var(--table-border, rgb(54, 54, 54)) !important;
}
body.dark-mode .strats th.col-sticky-0,
body.dark-mode .strats th.col-sticky-1,
body.dark-mode .strats th.col-sticky-2 {
  background-color: var(--table-header, rgb(17, 17, 24)) !important;
}
body.dark-mode .strats td.col-sticky-0,
body.dark-mode .strats td.col-sticky-1,
body.dark-mode .strats td.col-sticky-2 {
  background-color: var(--table-bg, rgb(28, 28, 33));
}
body.dark-mode .strats tr:hover td.col-sticky-0,
body.dark-mode .strats tr:hover td.col-sticky-1,
body.dark-mode .strats tr:hover td.col-sticky-2 {
  background-color: #555 !important;
}
body.dark-mode .summary-card {
  background-color: rgb(36, 36, 42);
  border-color: rgb(54, 54, 64);
  border-top-color: rgb(54, 54, 64);
  box-shadow: none;
}
body.dark-mode .summary-card.pnl-positive {
  background-color: rgba(46, 204, 113, 0.08);
  border-color: rgba(46, 204, 113, 0.3);
  border-top-color: #2ecc71;
}
body.dark-mode .summary-card.pnl-negative {
  background-color: rgba(231, 76, 60, 0.08);
  border-color: rgba(231, 76, 60, 0.3);
  border-top-color: #e74c3c;
}
body.dark-mode .summary-label {
  color: rgba(173, 190, 210, 0.65);
}
body.dark-mode .summary-value {
  color: rgb(173, 190, 210);
}
body.dark-mode .summary-card.pnl-positive .summary-value {
  color: #2ecc71;
}
body.dark-mode .summary-card.pnl-negative .summary-value {
  color: #e74c3c;
}

/* Process name link */
.process-link {
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #d44d47; /* brand red in light mode */
}
body.dark-mode .process-link {
  color: rgb(173, 190, 210);
}
.process-link:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
  color: #f3756c;
}

/* Chart icon link */
.chart-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  text-decoration: none;
  color: #888; /* neutral in light mode */
  transition: background-color 0.15s, color 0.15s;
  cursor: pointer;
}
body.dark-mode .chart-link {
  color: rgb(173, 190, 210);
}
.chart-link:hover {
  background-color: rgba(243, 117, 108, 0.2);
  color: #f3756c !important;
}

/* Comb. PNL link in total row */
.comb-pnl-link {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  border-bottom: 2px solid #f3756c;
  color: #d44d47;
  transition: background-color 0.15s;
}
body.dark-mode .comb-pnl-link {
  color: rgb(173, 190, 210);
}
.comb-pnl-link:hover {
  background-color: rgba(243, 117, 108, 0.15);
  color: #f3756c;
}

/* Compact header on mobile */
@media (max-width: 768px) {
  .summary-bar {
    gap: 6px;
  }
  .summary-card {
    flex: 1 1 80px;
    padding: 8px 10px;
  }
  .summary-value {
    font-size: 0.95rem;
  }
  .header {
    flex-wrap: wrap;
    gap: 4px;
  }
  .btn.btn-outline-custom {
    padding: 5px 10px;
    font-size: 0.8rem;
    margin-right: 2px;
  }
}

@media (max-width: 992px) {
  .strats-wrapper {
    max-height: calc(100vh - 160px);
  }
}

@media (max-width: 768px) {
  .strats-wrapper {
    max-height: calc(100vh - 140px);
  }

  /* Shrink font + padding so more columns fit on small screens */
  .strats th,
  .strats td {
    font-size: 0.72rem;
    padding: 4px 6px;
    white-space: nowrap;
  }

  /* Tighten sticky column widths */
  .strats td.col-sticky-0,
  .strats th.col-sticky-0 {
    min-width: 28px;
  }
  .strats td.col-sticky-1,
  .strats th.col-sticky-1 {
    min-width: 32px;
    left: 28px;
  }
  .strats td.col-sticky-2,
  .strats th.col-sticky-2 {
    min-width: 80px;
    left: 60px;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
